module.exports = {
	model: {
		media: {},
		// mediaTags: []
	},

	// methods: {
	// 	prepare: function(storage){
	// 		var langCode = (((storage || {}).user || {}).data || {}).langCode || 'de-at';
	// 		this.model.mediaTags = [];
	// 		var ce, categoryEntities = ((this.model.media || {}).cmsEntitiesCategories || {}).data || [];
	// 		var categoryAttributes, categoryTrlAttributes, tagTitle;
	//
	// 		for(ce in categoryEntities){
	// 			categoryAttributes = ((((categoryEntities[ce] || {}).children || {}).cms_categoriesData || {}).data || {}).attributes || {};
	// 			tagTitle = categoryAttributes.value || 'UNKNOWN_VALUE'
	// 			if((categoryTrlAttributes = (categoryAttributes.trls || {})[langCode]) && categoryTrlAttributes.name){
	// 				tagTitle = categoryTrlAttributes.name;
	// 			}
	//
	// 			this.model.mediaTags.push({ name: tagTitle });
	// 		}
	// 	}
	// },

	hooks: {
		showMediaDetails: function($element, options){
			this.model.media = options.media;
			this.refresh();
		}
	}
}